import {CreateNewTableButton} from "./CreateNewTableButton";

export const TableControls = () => {
  return (
      <div style={{display: "flex", flexDirection: "column", rowGap: "10px"}}>
          <CreateNewTableButton/>
      </div>
  )
}